import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import { AgColor } from '../../../stories/Styles/AgColor';
import AgTypography from '../../../stories/Styles/AgTypography';
import AgAccountProfileCard from '../../../stories/Components/Cards/AgAccountProfileCard';

import * as S from './styled';
import defaultAvatar from '../../../stories/Components/AgAvatar/defaultAvatar.svg';

const OrgOtherHeader = ({
  orgId,
  orgData,
  imageURL,
  label,
  description,
}: {
  orgId: string;
  orgData: any;
  imageURL: string;
  label: string;
  description: string;
}) => {
  const messages = useIntl().formatMessage;
  const navigate = useNavigate();

  return (
    <Stack direction='row' spacing={2}>
      <AgAccountProfileCard
        img={imageURL || defaultAvatar}
        name={orgData?.name || ''}
        accountID={'#c' + orgId}
        isSelected
        hideInfo
        idLabel={messages({ id: 'ORGANIZATION_ID' })}
        cardTitle={messages({ id: 'ORGANIZATION_DETAILS' })}
        onClick={() => navigate(-1)}
      />

      <Stack sx={S.contentStyle} gap={1} justifyContent='center'>
        <AgTypography
          message={label}
          contentStyle={'AP.H2.Bold'}
          component='h2'
          style={{ color: AgColor.grey8 }}
        />
        <AgTypography
          message={description}
          contentStyle={'AP.H4.Medium'}
          style={{ color: AgColor.grey6 }}
        />
      </Stack>
    </Stack>
  );
};

export default OrgOtherHeader;